import { TableCell, TableSortLabel } from "@mui/material";
import type { TableCellProps } from "@mui/material";
import type { ReactNode } from "react";
import type { TableSort } from "hooks/useTableSort";

type SortableHeaderCellProps<Column extends string> = Readonly<
  Omit<TableCellProps, "children" | "sortDirection" | "onClick"> & {
    column: Column;
    sort: TableSort<Column> | null;
    onSort: (column: Column) => void;
    children: ReactNode;
  }
>;

export const SortableHeaderCell = <Column extends string>({
  column,
  sort,
  onSort,
  children,
  ...tableCellProps
}: SortableHeaderCellProps<Column>) => {
  const activeDirection = sort?.column === column ? sort.direction : null;

  return (
    <TableCell {...tableCellProps} sortDirection={activeDirection ?? false}>
      <TableSortLabel
        active={activeDirection != null}
        direction={activeDirection ?? "asc"}
        onClick={() => {
          onSort(column);
        }}
      >
        {children}
      </TableSortLabel>
    </TableCell>
  );
};
